import { AUTH_TOKEN } from "../config/constants";
import { getStorageValueToken } from "../utils/getMiniAppStorageData";
import { LOGIN_PEOPLE_DETAIL } from "../config/constants";

export const expireDate = (num) => {
  num = num * 1000;
  var now = Date.now();
  num = now + num;
  var date = new Date(num);
  return date.toString();
};

export const isExpire = () =>
  new Date(localStorage.getItem("expires_in")) > Date.now() ? false : true;

let loginAccess = null;
let loginAccessType = null;

// Fetch tokens during app initialization or elsewhere
export const initializeTokens = async () => {
  if (window.location.search.includes("miniapp")) {
    try {
      const [accessToken, tokenType] = await Promise.all([
        getStorageValueToken("access_token"),
        getStorageValueToken("token_type"),
      ]);

      if (accessToken && tokenType) {
        localStorage.setItem("access", accessToken);
        localStorage.setItem("accessType", tokenType);
      }
    } catch (error) {
      console.error("Error fetching tokens during initialization:", error);
    }
  }
};

export const isAuthenticated = () => {
  if (window.location.search.includes("miniapp")) {
    const token = localStorage.getItem("access");
    const type = localStorage.getItem("accessType");
    return token && type ? true : false;
  } else {
    return localStorage.getItem(AUTH_TOKEN) && !isExpire() ? true : false;
  }
};

// export const isAuthenticated = () => {
//   return localStorage.getItem(AUTH_TOKEN) && !isExpire() ? true : false;
// };

// export const isAuthenticated = () => {
//   return localStorage.getItem(AUTH_TOKEN) && !isExpire() ? true : false;
// };

export const GetParamByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};
if (window.location.search.includes("miniapp")) {
  window.addEventListener("load", () => {
    initializeTokens();
  });
}
